import React from 'react';
import { SectionInstance } from '../types';
import { sfCtaText, sfCtaUrl } from './sectionHelpers';

const NavMega: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const menuGroups = (c.menu_groups || []) as Array<{ group_label: string; links: string }>;
  const logoAlt = c.logo_alt || 'Logo';

  return (
    <nav style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid rgba(0,0,0,0.08)', background: '#fff' }}>
      <div style={{ fontWeight: 700, fontSize: '1.25rem' }}>
        {c.logo_url ? <img src={c.logo_url} alt={logoAlt} style={{ height: 40 }} /> : <span>{logoAlt}</span>}
      </div>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
        {menuGroups.map((g, i) => (
          <span key={i} style={{ color: '#64748b', fontWeight: 500, cursor: 'pointer' }}>{g.group_label}</span>
        ))}
        {sfCtaText(c) && (
          <a href={sfCtaUrl(c)} style={{ padding: '10px 24px', borderRadius: 6, background: 'var(--brand-primary, #1a365d)', color: '#fff', fontWeight: 600, textDecoration: 'none' }}>
            {sfCtaText(c)}
          </a>
        )}
      </div>
    </nav>
  );
};
export default NavMega;
